import ReturnAddressChangeDialog from "./ReturnAddressChangeDialog";
// MUI
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";

export const ReturnAddress = ({
  returnData,
  setReturnData,
  setValue,
  watch,
}) => {
  const address = {
    Contact: watch("returnOrder.contact"),
    Email: watch("returnOrder.email"),
    Phone: watch("returnOrder.mobileNo"),
    Name: watch("returnOrder.name"),
    "Address 1": watch("returnOrder.address"),
    "Address 2": watch("returnOrder.address2"),
    City: watch("returnOrder.city"),
    County: watch("returnOrder.county"),
    Postcode: watch("returnOrder.postCode"),
    Country: watch("returnOrder.country"),
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Address
      </Typography>
      <Grid
        container
        spacing={{ xs: 2, md: 2 }}
        columns={{ xs: 4, sm: 8, md: 12 }}
      >
        {Object.entries(address).map(([key, value], i) => {
          if (value) {
            return (
              <Grid
                key={key}
                size={{
                  xs: 2,
                  sm: 4,
                  md: 4,
                }}
              >
                <TextField
                  size="small"
                  sx={{
                    "& .MuiFilledInput-root": {
                      backgroundColor: "grey",
                    },
                  }}
                  fullWidth
                  id={`${key}-input`}
                  label={key}
                  value={value || ""}
                  slotProps={{
                    input: {
                      readOnly: true,
                    },
                  }}
                />
              </Grid>
            );
          }
        })}
        <Grid
          sx={{ display: "flex", alignItems: "center" }}
          size={{
            xs: 2,
            sm: 4,
            md: 4,
          }}
        >
          <FormControlLabel
            disabled
            control={<Switch checked={returnData.homeaddress} />}
            label="Residential"
          />
        </Grid>
      </Grid>
      <ReturnAddressChangeDialog
        setReturnData={setReturnData}
        setValue={setValue}
      />
    </Paper>
  );
};
